export function getBookingHeadcount(guestsCount?: number | null): number {
  return 1 + Math.max(0, guestsCount ?? 0);
}

export function getBookingHeadcountFromInteraction(interaction: {
  features?: { GuestInvite?: { guests?: unknown[] | null } | null } | null;
}): number {
  const guests = interaction.features?.GuestInvite?.guests;

  return getBookingHeadcount(Array.isArray(guests) ? guests.length : 0);
}
